import React, { type FC, useState } from "react";
import { WelcomeBackToPrimeModal as WelcomeBackToPrimeModalWith24HourWaiting } from "@components/WelcomeBackToPrimeModal";
import WelcomeBackToPrimeModal from "@components/WelcomeBackToPrimeModal/WelcomeBackToPrimePopup";
import { useGetCurrentSessionIfMeta } from "clientState/useGetCurrentSessionIfMeta/useGetCurrentSessionIfMeta";

import UserVerificationModal from "../UserVerificationModal";
import { TEN_MINUTES_IN_MS } from "./constants";
import type { UserVerificationManagerProps } from "./contract";

const isAtLeastXMillisecondsAgo = (
  creationTimestamp: number | string,
  milliseconds: number,
): boolean => {
  return Date.now() - new Date(creationTimestamp).getTime() >= milliseconds;
};

const UserVerificationManager: FC<UserVerificationManagerProps> = ({
  isMeta,
}) => {
  const [showWelcomeBackToPrimeModal, setshowWelcomeBackToPrimeModal] =
    useState(!isMeta);
  const { loading, currentSession, errors } =
    useGetCurrentSessionIfMeta(isMeta);
  const currentSessionIfMeta = !loading && !errors?.length && currentSession;
  const isSessionOlderThanTenMinutes =
    currentSessionIfMeta &&
    isAtLeastXMillisecondsAgo(
      currentSessionIfMeta.creationTimestamp,
      TEN_MINUTES_IN_MS,
    );

  const shouldShowUserVerificationModal =
    !showWelcomeBackToPrimeModal && isSessionOlderThanTenMinutes;

  const shouldShowWelcomePopup =
    showWelcomeBackToPrimeModal || (!isSessionOlderThanTenMinutes && !loading);

  const handleCloseModal = (): void => {
    setshowWelcomeBackToPrimeModal(true);
  };

  const shouldShowWelcomeBackToPrimeModalWith24HourWaiting =
    !isMeta || !currentSessionIfMeta;

  return (
    <>
      {shouldShowUserVerificationModal && (
        <UserVerificationModal onClick={handleCloseModal} />
      )}

      {shouldShowWelcomeBackToPrimeModalWith24HourWaiting && (
        <WelcomeBackToPrimeModalWith24HourWaiting />
      )}
      {shouldShowWelcomePopup &&
        !shouldShowWelcomeBackToPrimeModalWith24HourWaiting && (
          <WelcomeBackToPrimeModal />
        )}
    </>
  );
};

export default UserVerificationManager;
